module.exports = {
	defaultTitle: 'SeaPatrick',
	logo: 'https://seapatrick.netlify.com/favicon/logo-48.png',
	author: 'Serge Sipatrin (Sea Patrick)',
	url: 'https://seapatrick.netlify.com',
	legalName: 'Serge Sipatrin',
	defaultDescription:
		"I'm Serge Sipatrin or just Sea Patrick, a full stack developer, interested in the web, mobile & tech in general.",
	socialLinks: {
		twitter: 'http://www.twitter.com/seapatron1',
		github: 'https://github.com/serhiosipatron',
		linkedin: 'https://www.linkedin.com/in/sergey-sipatrin-3a3730116',
		instagram: 'https://www.instagram.com/sea_patrick',
		youtube: 'https://www.youtube.com/user/smakoshthegamer',
		google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou'
	},
	googleAnalyticsID: 'UA-132438459-2',
	themeColor: '#00c6ff',
	backgroundColor: '#00c6ff',
	siteRss: '/rss.xml',
	social: {
		facebook: '165244147328608',
		twitter: '@seapatron'
	},
	address: {
		city: 'Dnipro',
		region: 'Dniprovska',
		country: 'Ukraine',
		zipCode: '49100'
	},
	contact: {
		email: 'seaofpatrick@gmail.com',
		phone: '+212-663-53-27-61'
	},
	foundingDate: '2016'
}
